// extracted by mini-css-extract-plugin
export default {"melodyVideo":"sK-z","isFullWidth":"tK-z","landingPageVideo":"uK-z","play":"vK-z","iframeVideo":"wK-z","playHidden":"xK-z","fullwidth":"yK-z"};